var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12BEFCEF-F44D-4909-A240-3A9546A47D05") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.8929506,1.56990695 C15.3080008,1.83631362 14.6803581,2.01698758 14.0209034,2.09764893 C14.6942514,1.68321186 15.2096825,1.02585653 15.4539721,0.244973494 C14.8223561,0.62876886 14.1251686,0.907453568 13.3823018,1.05852678 C12.7874318,0.406269509 11.9412866,-8.8817842e-16 11.00277,-8.8817842e-16 C9.2022412,-8.8817842e-16 7.74234665,1.50050936 7.74234665,3.35011529 C7.74234665,3.61243818 7.77114617,3.86864875 7.82677159,4.11364893 C5.11753846,3.9737861 2.71518001,2.63967081 1.10731458,0.612433735 C0.826253,1.1064912 0.666362384,1.6821709 0.666362384,2.29668656 C0.666362384,3.45933642 1.24237891,4.48519296 2.11633681,5.08537535 C1.58202636,5.06701168 1.07950187,4.91593846 0.639562463,4.66482595 L0.639562463,4.70667804 C0.639562463,6.32967414 1.76378281,7.68420834 3.25445052,7.99249379 C2.98133543,8.0680304 2.69334015,8.10988248 2.39539878,8.10988248 C2.18486878,8.10988248 1.98127248,8.0884493 1.78164942,8.04761149 C2.19676254,9.37969824 3.40044777,10.3483818 4.82658273,10.3749398 C3.71129569,11.2732115 2.30502695,11.8070658 0.777613221,11.8070658 C0.514444226,11.8070658 0.255222506,11.7907307 5.32907052e-15,11.7611299 C1.44301476,12.7135051 3.15615817,13.2687926 4.99740626,13.2687926 C10.9948755,13.2687926 14.2731914,8.16297164 14.2731914,3.73495162 L14.2622585,3.30113661 C14.9028078,2.83155514 15.4569585,2.24156886 15.8929506,1.56990695 L15.8929506,1.56990695 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-v1.5---1.1---Arccos---Insight-Detail---1",
    transform: "translate(-978.000000, -1007.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(472.000000, 928.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(42.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Social/Twitter",
    transform: "translate(464.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#2C2C2C",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-color",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -5.000000)",
    id: "Black"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.959dde0aecc4da77eaad69bae8535028.svg";
export { ForwardRef as ReactComponent };